<template>
  <div class="form-body">
    <div class="form-group row">
      <label class="col-sm-6 col-md-2" v-if="webhook.isEnabled">Enabled</label>
      <label class="col-sm-6 col-md-2 text-danger" v-else>Disabled</label>
      <div class="col-md-10 col-sm-12">
        <switches v-model="webhook.isEnabled"
                  color="green">
        </switches>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-6 col-md-2">Type</label>
      <div class="col-auto">
        <b-form-select
                id="type"
                name="type"
                v-model="webhook.type"
                :options="webhookTypes"
                v-validate="'required'"
                :isValid="!errors.has('type')"
                class="form-control"
                data-vv-as="Type"
        >
        </b-form-select>
        <span v-show="errors.has('type')" class="error-message">{{ errors.first('type') }}</span>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-6 col-md-2">URL</label>
      <div class="col-sm-6 col-md-10">
        <input
                type="text"
                name="webhookUrl"
                placeholder="Type webhook url here"
                v-model="webhook.url"
                v-validate="'required|url'"
                data-vv-as="url"
                :class="{'is-invalid': errors.has('webhookUrl')}"
                class="form-control"
        />
        <span
                v-show="errors.has('webhookUrl')"
                class="error-message"
        >
              {{ errors.first('webhookUrl') }}
            </span>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-6 col-md-2">Params</label>
      <div class="col-sm-6 col-md-10">
        <div class="table-responsive">
          <table class="table table-bordered no-wrap">
            <thead v-if="webhook.params.length > 0">
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>Value</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(param, index) of webhook.params" :key="index">
                <td>
                  <b-form-select
                    id="type"
                    name="type"
                    v-model="param.type"
                    :options="webhookParamsTypes"
                    v-validate="'required'"
                    :isValid="!errors.has(`paramType${index}`)"
                    data-vv-as="Type"
                    class="form-control"
                  >
                  </b-form-select>
                  <div
                    v-show="errors.has(`paramType${index}`)"
                    class="error-message"
                  >
                    {{ errors.first(`paramType${index}`) }}
                  </div>
                </td>
                <td>
                  <input
                          :name="`paramName${index}`"
                          type="text"
                          placeholder="Enter field name"
                          v-model="param.name"
                          :class="{'is-invalid': errors.has(`paramName${index}`)}"
                          data-vv-as="Name"
                          v-validate="'required'"
                          class="form-control"
                  >
                  <div
                          v-show="errors.has(`paramName${index}`)"
                          class="error-message"
                  >
                  {{ errors.first(`paramName${index}`) }}
                  </div>
                </td>
                <td>
                  <input
                          v-if="param.type==='string'"
                          type="text"
                          :name="`paramValue${index}`"
                          placeholder="Enter param value"
                          v-model="param.value"
                          :class="{'is-invalid': errors.has(`paramValue${index}`)}"
                          v-validate="'required'"
                          :isValid="!errors.has(`paramValue${index}`)"
                          data-vv-as="Value"
                          class="form-control"
                  />
                  <input
                    v-if="param.type==='path'"
                    type="text"
                    :name="`paramValue${index}`"
                    placeholder="Enter path to data"
                    v-model="param.value"
                    :class="{'is-invalid': errors.has(`paramValue${index}`)}"
                    v-validate="'required'"
                    :isValid="!errors.has(`paramValue${index}`)"
                    data-vv-as="Value"
                    class="form-control"
                  />
                  <b-form-select
                          v-else-if="param.type==='others'"
                          :name="`paramValue${index}`"
                          v-model="param.value"
                          :options="webhookOtherValues"
                          v-validate="'required'"
                          :isValid="!errors.has(`paramValue${index}`)"
                          data-vv-as="Value"
                          class="form-control"
                  >
                  </b-form-select>
                  <b-form-select
                          v-else-if="param.type==='form'"
                          v-model="param.value"
                          :options="questions"
                          text-field="fieldName"
                          value-field="fieldName"
                          :name="`paramValue${index}`"
                          v-validate="'required'"
                          :isValid="!errors.has(`paramValue${index}`)"
                          data-vv-as="Value"
                          class="form-control"
                  >
                  </b-form-select>
                  <div
                          v-show="errors.has(`paramValue${index}`)"
                          class="error-message"
                  >
                  {{ getParamValueError(index) }}
                  </div>
                </td>
                <td class="text-center">
                  <a
                          class=""
                          @click="removeParam(index)"
                  >
                    <i class="mdi mdi-delete"></i>
                  </a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4">
                  <button class="btn btn-secondary btn-rounded btn-sm" @click="addParam">
                    <i class="mdi mdi-plus"></i> Add Param
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <button class="btn btn-info" @click="submit">
        Save Webhook Settings
      </button>
    </div>
  </div>
</template>
<script>
import uuid from 'uuid/v1';
import Switches from 'vue-switches';
import WEBHOOK from '@/graphql/Webhooks/Webhook.gql';
import WEBHOOK_TYPES from '@/graphql/Webhooks/Types.gql';
import CREATE_OR_UPDATE_WEBHOOK from '@/graphql/Webhooks/CreateOrUpdateWebhook.gql';
import QuestionsCompact from '@/graphql/Questions/QuestionsCompact.gql';

export default {
  components: {
    Switches,
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    webhookParamsTypes: () => [
      {value: 'form', text: 'Lead Form Field'},
      {value: 'others', text: 'Other Lead Data'},
      {value: 'string', text: 'String'},
      {value: 'path', text: 'Lead Data Path'},
    ],
    webhookOtherValues: () => [
      {value: 'leadId', text: 'Lead ID'},
      {value: 'campaignId', text: 'Campaign ID'},
      {value: 'visitorInput', text: 'Visitor Input'},
      {value: 'agentNotes', text: 'Agent Notes'},
    ],
  },
  data() {
    return {
      webhook: {
        isEnabled: false,
        url: '',
        type: null,
        params: [{ id: uuid(), name: '', type: 'string', initialValueOpts: {}, value: '' }],
      },
      webhookTypes: [],
      questions: [],
    };
  },
  methods: {
    getParamValueError(index) {
      return this.webhook.params[index].type === 'Form Field' && !this.questions.length
        ? 'Add questions to select this option or select other type in the row.'
        : this.errors.first(`paramValue${index}`);
    },
    addParam() {
      this.webhook.params = [
        ...this.webhook.params,
        { id: uuid(), name: '', type: 'Form Field', initialValueOpts: {}, value: '' },
      ];
    },
    async createOrUpdateWebhook() {
      const { type, params, ...data } = this.webhook;
      const newParams = params.map(param => {
        const { value, initialValueOpts, ...rest } = param;
        if (typeof value === 'object') {
          return { value: JSON.stringify(value), ...rest };
        }
        return { value, ...rest };
      });
      try {
        await this.$apollo.mutate({
          mutation: CREATE_OR_UPDATE_WEBHOOK,
          variables: {
            campaignId: this.campaignId,
            webhook: { ...data, typeId: type.id, params: newParams },
          },
        });
        this.$notify({
          group: 'success',
          type: 'success',
          text: 'Saved',
        });
      } catch (e) {
        this.$notify({
          group: 'error',
          type: 'error',
          text: e.message,
        });
      }
    },
    removeParam(index) {
      this.webhook.params = this.webhook.params.filter((_, i) => i !== index);
    },
    async submit() {
      try {
        const valid = await this.$validator.validateAll();
        if (!valid) {
          return;
        }
      } catch (e) {
        return;
      }
      try {
        await this.createOrUpdateWebhook();
      } catch (e) {
        this.$notify({
          group: 'error',
          type: 'error',
          text: e.message,
        });
      }
    },
  },
  apollo: {
    webhookTypes: {
      query: WEBHOOK_TYPES,
      fetchPolicy: 'network-only',
      result({ data, loading }) {
        if (!loading) {
          this.webhookTypes = data.webhookTypes.map(({ id, type }) => ({
            text: type,
            value: {
              id,
              type,
              __typename: 'WebhookType',
            },
          }));
        }
      },
    },
    webhook: {
      query: WEBHOOK,
      fetchPolicy: 'network-only',
      loadingKey: 'showSpinner',
      variables() {
        return {
          campaignId: this.campaignId,
        };
      },
      update(data) {
        if (data.webhook.id === null) {
          return this.webhook;
        }
        const { isEnabled, url, type, params } = data.webhook;
        const newParams = params.map(param => {
          const { type, value, __typename, ...rest } = param;
          let newValue = value;

          try {
            newValue = JSON.parse(value);
          } catch (e) {
            newValue = value;
          }

          const initialValueOpts = {
            [type]: newValue,
          };

          return { type, value: newValue, initialValueOpts, ...rest };
        });

        return { isEnabled, url, type, params: [...newParams] };
      },
    },
    questions: {
      query: QuestionsCompact,
      fetchPolicy: 'network-only',
      variables() {
        return {
          where: JSON.stringify({ campaignId: +this.campaignId }),
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.questions = data.questions.result.map(({ id, fieldName }) => ({
            id,
            fieldName,
          }));
        }
      },
    },
  },
};
</script>
<style scoped>
table .form-control {
  display: block;
}

table td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/Webhook.vue